import { Link, useLocation } from 'react-router-dom';
import { useI18n } from '../i18n';
import useOnline from '../lib/useOnline';
export default function OfflineNotice() {
  const online = useOnline(), { locale } = useI18n(), { pathname } = useLocation();
  if (online || pathname === '/id' || pathname === '/offline') return null;
  return <aside role="status" className="relative z-40 px-4 py-3 bg-brand-green text-white text-sm text-center">
    <Link to="/offline" className="underline">{locale === 'da' ? 'Du er offline · Åbn kamera, offline-fund og Skuret' : 'You are offline · Open camera, offline finds and the Shed'}</Link>
  </aside>;
}
